import { StepType, useTour } from '@reactour/tour';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToQuickCreateDealSteps = () => {
  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const quickCreateDealSteps: StepType[] = [
    {
      content:
        'Click on the + Create button at the upper left corner of your screen.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.CREATE}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 200);
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginTop: 29 }),
      },
    },
    {
      content: 'Click on the Create Deal option.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.DEAL}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 500);
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginTop: 23 }),
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          content={
            // eslint-disable-next-line max-len
            'Fill out the details like deal name, pipeline, stage, amount, closed date, and deal owner.'
          }
          type="Create Deal"
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.FORM.GENERAL.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="global_create_panel_header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.FORM.GENERAL.FORM}"]`,
      ],
      stepInteraction: false,
      position: 'left',
      styles: {
        popover: (base) => ({ ...base }),
      },
    },
    {
      content: 'Click Save and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.FORM.GENERAL.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
      styles: {
        popover: (base) => ({ ...base, top: -8, width: 480 }),
      },
    },
  ];

  const showQuickCreateDealSteps = () => {
    setTimeout(() => {
      setSteps?.(quickCreateDealSteps);
      setIsOpen(true);
    }, 300);
  };

  return showQuickCreateDealSteps;
};

export default useGetHowToQuickCreateDealSteps;
